<template>
    <div>
        <div v-for="(user, index) in user_data" :key="index" 
            :class="source !== 'server' ? 'd-inline-flex' : 'd-flex'"
            :style="source !== 'server' && index < owner_count - 1 ? `border-right: 1px solid white; margin-right:24px; padding-right:24px;` : ``" >
            
            <div v-if="!['partner', 'secondary'].includes(user.user_type)" 
                class="d-inline-flex align-items-center">
                <v-tooltip top content-class="contact_tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            icon
                            x-small
                            class="mt-n1 mr-1"
                            :color="button_color"
                            v-bind="attrs"
                            v-on="on"
                            target="_blank"
                            @click.stop
                            :href="`mailto:${user.user_email}`">
                            <v-icon>mdi-email</v-icon>
                        </v-btn>                            
                    </template>
                    <span>Email</span>
                </v-tooltip>

                <v-tooltip top content-class="contact_tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            icon
                            x-small
                            class="mt-n1 mr-1"
                            :color="button_color"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="beginCall(user.user_phone)">
                            <v-icon>mdi-phone</v-icon>
                        </v-btn>
                    </template>
                    <span>Call</span>
                </v-tooltip>
                
                <div v-if="!['secondary'].includes(user.user_type)"
                    :class="text_styles"
                    class="d-flex d-inline">
                    <div class="d-inline">{{ user.user_name || user.first_name + ' ' + user.last_name }}</div>
                    <v-divider v-if="source === 'buyer' && (user.city || user.state)" class="d-inline pewter mx-4" vertical></v-divider>
                    <div v-if="source === 'buyer'" class="d-inline">{{ user.city }}{{ user.city && user.state ? ', ': ' ' }}{{ user.state }}</div>
                </div>
            </div>
        </div>

        <div v-if="partnerNames.length && source === 'server'"
            :class="text_styles"
            class="mt-2 italicized">
            <span style="text-decoration: italics" v-for="partner in partnerNames" :key="partner">{{ partner }}<br></span>
        </div>
        
        <div v-if="partnerNames.length && source !== 'server'"
            class="flex_column mt-2 text_popup">
            <span v-for="(partner, ndx) in partnerNames" :key="partner">{{ partner }}{{ ndx+1 != partnerNames.length ? ', ':'' }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UserData_Dashboard',

        props: {
            user_data: {
                type: Array,
                required: true
            },
            source: { // 'dashboard' or 'buyer' or 'server'
                type: String,
                required: true
            }
        },

        data () {
            return {
                partnerNames: []
            }
        },

        computed: {
            button_color () {
                return this.source !== 'server' ? 'white' : 'primary lighten-1'
            },
            text_styles () {
                return this.source !== 'server' ? 'text_popup' : 'text_inline'
            },
            owner_count () {
                return this.user_data.filter(user => user.user_type == 'owner').length
            },
            partners () {
                return this.user_data.filter(user => user.user_type == 'partner')
            }
        },

        watch: {
            partners: {
                handler ( val ) {
                    if ( val || val.length ) {
                        this.getPartnerNames()
                    }
                },
                immediate: true
            }
        },

        methods: {
            beginCall: function ( digits ) {
                window.open(`tel:${digits}`)
            },

            getPartnerNames: function () {
                if ( this.partners && this.partners.length ) {
                    const hasNorthwestern = this.partners.some(user => user.user_name.includes("Northwestern"));
                    
                    // Filter out partners containing "Northwestern" in user_name
                    let filteredPartners = this.partners
                        .filter(user => !user.user_name.includes("Northwestern"))
                        .map(user => user.user_name); // Extract user_name only

                    // Add "Northwestern Mutual" only if any were removed
                    if (hasNorthwestern) {
                        filteredPartners.unshift("Northwestern Mutual");
                    }

                    this.partnerNames = filteredPartners.length ? filteredPartners : [];
                }
            }
        }
    }
</script>

<style scoped>
    .contact_tooltip {
        font-size: .8rem !important;
        padding: .25rem .8rem !important;
        margin-top: .2rem !important;
    }
    .text_popup {
        color: white;
        font-size: 1rem;
    }
    .text_inline {
        color: inherit;
        font-size: inherit;
    }
    .italicized {
        font-style: italic;
    }
    .d-inline-flex {
        display: inline-flex;
    }
    .align-items-center {
        align-items: center;
    }
    .d-flex {
        display: flex;
    }
    .flex-column {
        flex-direction: column;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserData_Dashboard.vue